import { gql } from "@apollo/client";

import { remoteApiSpecFragment } from "../fragments";

export const getRemoteApiSpecs = gql`
    query getRemoteApiSpecs {
        remoteApiSpecs {
            ...RemoteApiSpec
        }
    }
    ${remoteApiSpecFragment}
`;
